import Request from '../../request';
const BASE_URI_GO_API = process.env.API_GO_URL + '/api/v1';

const GetReservaId = async(solicitacaoID) => {
    try {
        return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/reserva/solicitacao/${solicitacaoID}`);

    } catch(error) {
        throw new Error(`Erro ao carregar detalhe das notificações`);
    }
}

const GetBoletoInvestidor = async (id) => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/reserva/boleto/${id}`)
}

export default {GetReservaId, GetBoletoInvestidor}



// WEBPACK FOOTER //
// ./src/services/api/reservaInvestimento/index.js